import React from 'react';

import { Box } from '@opendoor/atoms/box';

export interface MethodBadgeAnchorProps {
  /**
   * Badge anchored to the top-right corner of the method button. The "last
   * used" pill lives here; GROWTH-1617 owns the pill and the last-used lookup.
   * This component owns only the anchor geometry, so passing nothing renders
   * the button alone.
   */
  badge?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Positions an optional badge at the top-right corner of a method button,
 * overlapping its top edge. The badge is absolutely positioned so it never
 * shifts the button's own box, letting the same anchor sit on Google, Apple,
 * or the email CTA without changing their layout.
 */
export const MethodBadgeAnchor: React.FC<MethodBadgeAnchorProps> = ({ badge, children }) => (
  <Box className="relative w-full">
    {children}
    {badge ? (
      <Box className="absolute -top-2 right-3 z-10" data-testid="method-badge-anchor-slot">
        {badge}
      </Box>
    ) : null}
  </Box>
);
